import { useAppStore } from '../stores/useAppStore';

const COOKIE_NAME = 'bedtimer_token';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

function cookiePath(): string {
  const base = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '');
  return base || '/';
}

export function getTokenCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const prefix = COOKIE_NAME + '=';
  for (const part of document.cookie.split(';')) {
    const c = part.trim();
    if (c.startsWith(prefix)) {
      const v = decodeURIComponent(c.slice(prefix.length));
      return v || null;
    }
  }
  return null;
}

export function setTokenCookie(token: string): void {
  if (typeof document === 'undefined' || !token) return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie =
    `${COOKIE_NAME}=${encodeURIComponent(token)}` +
    `; Max-Age=${ONE_YEAR_SECONDS}` +
    `; Path=${cookiePath()}` +
    `; SameSite=Strict${secure}`;
}

export function clearTokenCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie =
    `${COOKIE_NAME}=` +
    `; Max-Age=0` +
    `; Path=${cookiePath()}` +
    `; SameSite=Strict`;
}

/**
 * Reconcile the cookie with the persisted zustand store after hydration.
 * Store wins when both have values but disagree (most-recent setSettings call).
 * Otherwise we copy whichever side has the value to fill the other.
 */
export function syncTokenWithCookie(): void {
  const stored = useAppStore.getState().settings.apiToken?.trim() || '';
  const cookie = getTokenCookie() || '';
  if (stored && stored !== cookie) {
    setTokenCookie(stored);
    return;
  }
  if (cookie && !stored) {
    useAppStore.getState().setSettings({ apiToken: cookie });
  }
}
